"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const react_router_dom_1 = require("react-router-dom");
const react_hook_form_1 = require("react-hook-form");
const user_login_1 = require("@App/entities/schemas/user/user-login");
const InputTextForm_1 = __importDefault(require("@App/kit/fields/v2/InputTextForm"));
const zod_1 = require("@hookform/resolvers/zod");
const user_login_2 = require("@App/forms/user/user-login");
const MfaForm_1 = __importDefault(require("@App/kit/scenes/LoginScene/LoginForm/MfaForm"));
const LoginForm = (props) => {
    const { mfaFunc, loginFunc, isFirstStepDone, mfaType, mfaContactPoint } = props;
    const loginFormFields = user_login_2.userLoginFormFields;
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        delayError: 750,
        resolver: (0, zod_1.zodResolver)(user_login_1.LoginFormSchema),
    });
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("form", { className: "login-form", onSubmit: methods.handleSubmit(isFirstStepDone ? mfaFunc : loginFunc) },
            react_1.default.createElement("input", { type: "text", id: 'autoCompleteOff', autoComplete: 'off', style: { display: 'none' } }),
            isFirstStepDone ? (react_1.default.createElement(MfaForm_1.default, { codeField: loginFormFields.code, mfaType: mfaType, mfaContactPoint: mfaContactPoint })) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h3", null, "Login to The MLC Portal"),
                react_1.default.createElement(InputTextForm_1.default, Object.assign({}, loginFormFields.username)),
                react_1.default.createElement(InputTextForm_1.default, Object.assign({}, loginFormFields.password)))),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', icon: common_1.ICONS.arrow_forward, disabled: !methods.formState.isValid }, "Login"),
            react_1.default.createElement(react_router_dom_1.Link, { className: 'small bold link', to: "/forgot-password" }, "Forgot password?"))));
};
exports.default = LoginForm;
